// R-47: the pure check on an affiliate link (lib/affiliate.ts uses it; tests/money_r3_test.ts runs it under Deno).
/** Only an https link that is not the plain source link counts. */
export function cleanAffiliate(v: unknown, url: string | null): string | null {
  if (typeof v !== 'string' || !/^https:\/\/\S+$/.test(v) || v.length > 2000) return null
  return v === url ? null : v
}
